module.exports = __webpack_public_path__ + "img/1493448626.5796ffeb.jpg";